import React from "react";
import { useTranslation } from "react-i18next";
import PinInput from "react-pin-input";
import useTheme from "@material-ui/core/styles/useTheme";
import Box from "@material-ui/core/Box/Box";
import { FormHelperText, makeStyles, Typography } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    margin: theme.spacing(1),
    transition: "opacity 0.2s ease-in-out",
  },
  disabled: {
    opacity: 0.5,
    pointerEvents: "none",
  },
  label: {
    marginBottom: theme.spacing(1),
  },
  helperText: {
    minHeight: 20,
    marginTop: theme.spacing(0.75),
    marginBottom: theme.spacing(0.75),
  },
}));

const PinValidation = (props: IProps) => {
  const { onChange, error, label, isBlocked, className } = props;
  const theme = useTheme();
  const { t } = useTranslation();
  const classes = useStyles();

  // Methods
  const _onChange = (value: string) => {
    onChange(value);
  };

  return (
    <Box
      className={`${classes.root} ${isBlocked ? classes.disabled : ""} ${
        className ?? ""
      }`}
    >
      {label !== undefined && (
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          className={classes.label}
        >
          <Typography align="center" variant="subtitle1">{`${
            label === "" ? t("enter_pin") : ""
          }`}</Typography>
        </Box>
      )}
      <PinInput
        length={4}
        initialValue=""
        secret
        type="numeric"
        inputMode="number"
        style={{ margin: "auto" }}
        inputStyle={{
          width: "40px",
          height: "40px",
          margin: "0px 10px",
          ...(error && { border: `1px solid ${theme.palette.error.main}` }),
          ...(isBlocked && {
            backgroundColor: theme.palette.action.disabledBackground,
            color: theme.palette.text.disabled,
            cursor: "not-allowed",
          }),
        }}
        inputFocusStyle={{
          border: `1px solid ${theme.palette.primary.main}`,
        }}
        onChange={_onChange}
        disabled={isBlocked}
      />
      {error !== undefined && (
        <FormHelperText className={classes.helperText} error={error !== ""}>
          {error !== "" ? t(error) : ""}
        </FormHelperText>
      )}
    </Box>
  );
};

interface IProps {
  label?: string;
  error?: string;
  isBlocked?: boolean;
  className?: string;
  onChange: (value: string) => void;
}

export default PinValidation;
